import { Link } from 'react-router-dom';
import { Plus, Clock, Download } from 'lucide-react';
import { useProjects } from '../hooks/useProjects';

export function ProjectsPage() {
  const { projects, isLoading } = useProjects();

  return (
    <div className="flex-1 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-semibold text-white">Projects</h1>
            <p className="text-zinc-400 mt-1">Your pattern drafting projects</p>
          </div>
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 bg-progeny-600 hover:bg-progeny-500 rounded-lg text-white text-sm transition-colors"
          >
            <Plus className="w-4 h-4" />
            New Project
          </Link>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-zinc-800/50 rounded-xl h-48 animate-pulse" />
            ))}
          </div>
        ) : projects.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-zinc-400">No projects yet. Start by creating a new pattern.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {projects.map((project) => (
              <Link
                key={project.id}
                to={`/projects/${project.id}`}
                className="bg-zinc-800/50 hover:bg-zinc-800 border border-zinc-700/50 rounded-xl p-4 transition-colors group"
              >
                <div className="aspect-video bg-zinc-900 rounded-lg mb-4 overflow-hidden">
                  {project.thumbnail ? (
                    <img
                      src={project.thumbnail}
                      alt={project.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-zinc-600">
                      No preview
                    </div>
                  )}
                </div>
                <h3 className="font-medium text-white truncate">{project.name}</h3>
                <div className="flex items-center justify-between mt-2 text-xs text-zinc-500">
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {new Date(project.updatedAt).toLocaleDateString()}
                  </span>
                  {project.hasDxf && (
                    <span className="flex items-center gap-1 text-progeny-400">
                      <Download className="w-3 h-3" />
                      DXF Ready
                    </span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

